import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    root: {
        margin: 'auto',
    },
    cardHeader: {
        padding: theme.spacing(1, 2),
    },
    list: {
        width: 200,
        height: 230,
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
    listHeader: {
        textAlign: 'center',
    },
    fieldLabel:{
        fontWeight:'500'
    },
    currentCard:{
        border:'3px solid '+theme.palette.primary.main
    },
    borderDisable:{
        border:'none !important',
        boxShadow:'none !important'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.overlayBg.background,
      }

}));

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            
            MuiPaper:{
                root:{
                    color:'unset !important',

                }
            },
            MuiCard:{
                root:{
                    margin:'5px 0px !important',
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",

                }
            },
            MuiCardContent:{
                root:{
                    width:'100%',
                    padding:'5px !important',
                   
                }
               
            }
        },
    })
}
